import { SecondaryButton } from '@procurify/ui'
import styled from 'styled-components'

export const ConversationChipStyled = styled(SecondaryButton)`
  min-height: auto;
  min-width: auto;
  padding: ${(props) => props.theme.typography.pxToRem(8)}
    ${(props) => props.theme.typography.pxToRem(12)};
  border-color: ${(props) => props.theme.colors.ai};
  color: ${(props) => props.theme.colors.ai};
  font-weight: ${(props) => props.theme.fontWeights.semibold};
  line-height: ${(props) => props.theme.typography.pxToRem(16)};
  box-shadow: none;

  &:hover {
    background: ${(props) => props.theme.colors.alert.ai.background};
    border-color: ${(props) => props.theme.colors.ai};
    color: ${(props) => props.theme.colors.ai};
    box-shadow: none;
  }

  &:focus-visible {
    outline: ${(props) => props.theme.typography.pxToRem(2)} solid
      ${(props) => props.theme.colors.focus};
    outline-offset: ${(props) => props.theme.typography.pxToRem(2)};
    border-color: ${(props) => props.theme.colors.ai};
  }
`
